export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand ${compact ? "brand--compact" : ""}`.trim()}>
      <span className="brand__mark" aria-hidden="true">
        <img src="/brand/veha-mark.png" alt="" width="1254" height="1254" />
      </span>
      <span className="brand__copy">
        <strong>{import.meta.env.VITE_VEKHA_BETA === "true" ? "ВЕХА · БЕТА" : "ВЕХА"}</strong>
        {compact ? null : <small>Академия гипнотерапии</small>}
      </span>
    </div>
  );
}
